import { useState, useEffect } from "react";
import { Loader2, BarChart3 } from "lucide-react";
import { PageHeader, EmptyState } from "@/components/admin/ui";
import { api } from "@/lib/api";
import { formatGs } from "@/lib/format";

const Reports = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/admin/reports/profitability").then((r) => setRows(r.data)).finally(() => setLoading(false)); }, []);

  const totals = rows.reduce((a, r) => ({ sales: a.sales + r.sales, revenue: a.revenue + r.revenue, cost: a.cost + r.cost, profit: a.profit + r.profit }), { sales: 0, revenue: 0, cost: 0, profit: 0 });

  return (
    <div>
      <PageHeader title="Centro de Reportes" subtitle="Rentabilidad por servicio calculada automáticamente" />

      {loading ? <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-indigo-600" /></div>
        : rows.length === 0 ? <EmptyState icon={BarChart3} text="Sin ventas pagadas todavía." />
        : (
          <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full text-sm min-w-[560px]">
                <thead className="bg-slate-50 text-slate-500 text-xs uppercase">
                  <tr>
                    <th className="text-left px-4 py-3">Servicio</th>
                    <th className="text-right px-4 py-3">Ventas</th>
                    <th className="text-right px-4 py-3">Receita</th>
                    <th className="text-right px-4 py-3">Costo</th>
                    <th className="text-right px-4 py-3">Lucro</th>
                    <th className="text-right px-4 py-3">Margen</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {rows.map((r) => (
                    <tr key={r.service} className="hover:bg-slate-50" data-testid={`report-${r.service}`}>
                      <td className="px-4 py-3 font-medium text-slate-800">{r.service}</td>
                      <td className="px-4 py-3 text-right">{r.sales}</td>
                      <td className="px-4 py-3 text-right">{formatGs(r.revenue)}</td>
                      <td className="px-4 py-3 text-right text-slate-500">{formatGs(r.cost)}</td>
                      <td className="px-4 py-3 text-right font-semibold text-emerald-600">{formatGs(r.profit)}</td>
                      <td className="px-4 py-3 text-right">{r.revenue ? Math.round((r.profit / r.revenue) * 100) : 0}%</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot className="bg-slate-50 font-semibold text-slate-900">
                  <tr>
                    <td className="px-4 py-3">Total</td>
                    <td className="px-4 py-3 text-right">{totals.sales}</td>
                    <td className="px-4 py-3 text-right">{formatGs(totals.revenue)}</td>
                    <td className="px-4 py-3 text-right">{formatGs(totals.cost)}</td>
                    <td className="px-4 py-3 text-right text-emerald-600">{formatGs(totals.profit)}</td>
                    <td className="px-4 py-3 text-right">{totals.revenue ? Math.round((totals.profit / totals.revenue) * 100) : 0}%</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        )}
      <p className="text-xs text-slate-400 mt-4">La exportación a CSV/Excel estará disponible próximamente.</p>
    </div>
  );
};

export default Reports;
